import { createRenderer, } from '@haaretz/fela-utils';

const styleRenderer = createRenderer({ isRtl: true, });

export default styleRenderer;
